/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnableTOTPRequest
 */
export interface EnableTOTPRequest {
    /**
     * 
     * @type {string}
     * @memberof EnableTOTPRequest
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof EnableTOTPRequest
     */
    otp: string;
}

export function EnableTOTPRequestFromJSON(json: any): EnableTOTPRequest {
    return EnableTOTPRequestFromJSONTyped(json, false);
}

export function EnableTOTPRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableTOTPRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'otp': json['otp'],
    };
}

export function EnableTOTPRequestToJSON(value?: EnableTOTPRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'otp': value.otp,
    };
}


